<template>
  <div>
    <footerComponent />
  </div>
</template>

<script>
  const dirName = process.env.siteName === 'yongligao' || process.env.siteName === 'bet365luck' || process.env.siteName === 'dafa' || process.env.siteName === 'b026' || process.env.siteName === 'b027site' || process.env.siteName === 'b027sport' ? process.env.siteName : 'common'
  // const footerComponent = () => import('@/components/different/' + dirName + '/footer/footer')
  const footerComponent = require('@/components/different/' + dirName + '/footer/footer')
  export default {
    name: 'v-footer',
    components: {
      footerComponent
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .footer-wrapper
    background #efefef
    width 100%
    margin-top 30px
    border-top solid 2px #dcdcdc
    .wrap
      width 1000px
      margin 0 auto
      overflow hidden
      padding 34px 0 66px
      border-bottom solid 1px #dcdcdc
      .con
        display flex
        align-items center
        justify-content space-between
        margin-bottom 30px
        .list
          flex 1
          display flex
          margin-right 30px
          align-items center
          justify-content space-between
          & > li
            display inline-flex
            font-size 14px
            color #222222
            align-items center
            & > img
              display block
            & > div
              margin-left 20px
              & > p:first-child
                margin-bottom 9px
        .other
          width 500px
          height 34px
    .copyright
      text-align center
      padding-top 25px
      font-size 14px
      color #222222
    .linkUl
      margin 0 auto
      width 780px
      li
        padding 0 5px
        float left
        a
          color #999
          font-size 12px

</style>



// WEBPACK FOOTER //
// footer.vue?50808cb0